<template>
  <div
    class="dropdown"
    @blur="dropdownOpen = false"
  >
    <button
      class="label body-3"
      @click="toggleDropdown()"
    >
      {{ label }}
    </button>
    <ul
      class="options"
      :class="{ active: dropdownOpen }"
    >
      <li
        v-for="item in items"
        :key="item.id"
      >
        <button
          class="options__item body-3"
          :class="{ wrap: optionWrap }"
          @click="itemClick(item)"
        >
          {{ item.label }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
  import type { DropdownItem } from '~/types/General/Elements/DropdownItem'

  defineProps({
    label: {
      type: String,
      required: true
    },
    items: {
      type: Array<DropdownItem>,
      required: false,
      default: []
    },
    optionWrap: {
      type: Boolean,
      required: false,
      default: true
    }
  })
  const emit = defineEmits(['select'])

  const dropdownOpen = ref<boolean>(false)

  function toggleDropdown() {
    dropdownOpen.value = !dropdownOpen.value
  }

  function itemClick(item: Object) {
    dropdownOpen.value = false

    emit('select', item)
  }

  // TODO: Click outside
</script>

<style lang="scss" scoped>
  @import '~/assets/styles/common.scss';

  .dropdown {
    cursor: pointer;
    position: relative;

    .label {
      color: $bt-blue;
      background-color: transparent;
      border: none;
      padding: rem(12);
      font-style: normal;
      font-weight: 500;
      font-size: rem(16);
      line-height: rem(16);

      &:after {
        content: url('~/assets/icons/arrow-full.svg');
        margin-left: rem(10);
        position: relative;
        top: -2px;
      }
    }
  }

  .options {
    background-color: $white;
    border-radius: 4px;
    display: none;
    padding: rem(16);
    position: absolute;
    top: 36px;
    list-style: none;

    &.active {
      display: block;
      z-index: 10;
    }

    &__item {
      color: $bt-blue;
      line-height: rem(24);
      margin-bottom: rem(8);
      white-space: nowrap;
      border: none;
      background-color: transparent;
      width: 100%;
      text-align: left;

      &.wrap {
        white-space: normal;
      }
    }
  }
</style>
